import { render } from "./ChangePhoto.vue?vue&type=template&id=bfd07498"
import script from "./ChangePhoto.vue?vue&type=script&lang=js"
export * from "./ChangePhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__